/* global $ */

export class MenuControl {
	constructor() {
		this.$menu = $('#menu')
		this.$toggle = $('.global-header .menu-toggle a')
		this.$links = this.$menu.find('nav li a')
		this.$body = $('body')
		this.$hoverImages = this.$menu.find('.hover-image img')

		this.$toggle.on('click', (e) => {
			e.preventDefault()

			if (this.$menu.hasClass('open')) {
				// if menu open, close it
				this.closeMenu()
			} else {
				// if menu closed, open it
				this.openMenu()
			}
		})

		// esc button
		$(window).on('keyup', (e) => {
			if (e.keyCode === 27) {
				this.closeMenu()
			}
		})

		// close menu, specifically for same page anchor links
		this.$links.on('click', () => {
			this.closeMenu()
		})

		// hover over links to show corresponding image (only shows up for large breakpoints)
		this.$links.each((index, link) => {
			const $link = $(link)
			const $img = $link.siblings('img')

			if ($img.length) {
				$link.on('mouseenter', function () {
					$img.addClass('show')
				})

				$link.on('mouseleave', function () {
					$img.removeClass('show')
				})
			}
		})
	}

	openMenu() {
		// update toggle
		this.$toggle.attr('aria-expanded', true).parent().addClass('open')

		// disable body scroll
		this.$body.addClass('no-scroll')

		// show the menu
		this.$menu.addClass('show')

		setTimeout(() => {
			// open the menu
			this.$menu.addClass('open')
		}, 10)
	}

	closeMenu() {
		if (this.$menu.hasClass('open')) {
			// update toggle
			this.$toggle.attr('aria-expanded', false).parent().removeClass('open')

			// transition end event
			this.$menu.find('.bg').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
				this.$menu.find('.bg').off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend')
				this.$menu.removeClass('open close show')
			})

			// close the menu
			this.$menu.addClass('close')

			// enable body scroll
			this.$body.removeClass('no-scroll')
		}
	}
}
